import { observer } from 'mobx-react-lite';
import React from 'react';

import { Notification, NotificationContainer } from '@flixbus/honeycomb-react';

import { notificationStore } from 'global/NotificationStore';

import styles from './styles.module.css';

const RootNotificationContainer = observer(() => {
	const { notifications } = notificationStore;
	return (
		<NotificationContainer extraClasses={styles.center} position="bottom-right">
			{Array.from(notifications, ([key, { label, header, appearance }]) => (
				<Notification
					toast
					appearance={appearance}
					closeProps={{
						'aria-label': 'Close',
						onClick: () => notificationStore.removeNotification(key),
					}}
					dismissCallback={() => notificationStore.removeNotification(key)}
					data-key={key}
					key={key}
				>
					<div>{header}</div>
					{Array.isArray(label) && (
						<ul>
							{label.map((singleLabel) => (
								<li key={singleLabel} className={styles.description}>
									{singleLabel}
								</li>
							))}
						</ul>
					)}
					{!Array.isArray(label) && <div className={styles.description}>{label}</div>}
				</Notification>
			))}
		</NotificationContainer>
	);
});

export default RootNotificationContainer;
